// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"28":"27ef5f0c","156":"e884481c","968":"2f559ef8"}[chunkId] + ".js";
};